<template lang="pug">
input.textbox-base(@input='updateValue')
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class TextboxBase extends Vue {
  /**
   * 値変更時イベント
   *  変更を画面側へ伝達し、v-modelで制御可能にする
   */
  private updateValue(event: Event) {
    this.$emit('input', (event.target as HTMLSelectElement).value)
  }
}
</script>

<style lang="stylus" scoped>
.textbox-base
  border 1px solid var(--color-default__border)
  appearance none
  outline none
</style>
